import { useEffect } from "react";
import SockJS from "sockjs-client";
import { Client } from "@stomp/stompjs";

function ChatSocketListener({ currentUser, selectedUserId, onMessageReceived, onMessageRead }) {
    useEffect(() => {
        if (!currentUser?.id || !selectedUserId) return;
      
        const token = localStorage.getItem("authToken");
        const socket = new SockJS(`${process.env.REACT_APP_API_URL}/ws?token=${token}`);
        const client = new Client({
          webSocketFactory: () => socket,
      
          onConnect: () => {
            console.log("📨 WebSocket connected to chat");
      
            // ✅ Réception d'un nouveau message
            client.subscribe(`/topic/chat/${currentUser.id}`, (message) => {
              const payload = JSON.parse(message.body);
              console.log("🔔 Message WebSocket:", payload);
      
              if (payload.senderId === selectedUserId) {
                onMessageReceived(payload);
                window.dispatchEvent(new Event("refresh-notifications"));
                window.dispatchEvent(new Event("refresh-contacts"));
              }
            });
      
            // ✅ Marquage comme lu
            client.subscribe(`/topic/read/${currentUser.id}`, (msg) => {
              const readNotice = JSON.parse(msg.body);
              if (readNotice.senderId === selectedUserId) {
                onMessageRead(); // 🔁 cette ligne doit être dans le tableau de dépendance
                window.dispatchEvent(new Event("refresh-notifications"));
                window.dispatchEvent(new Event("refresh-contacts"));
              }
            });
          },
        });
      
        client.activate();
        return () => client.deactivate();
      }, [currentUser?.id, selectedUserId, onMessageReceived, onMessageRead]); // ✅ Ajouté ici
      
    return null;
}

export default ChatSocketListener;
